import { render, staticRenderFns } from "./PwaUpdater.vue?vue&type=template&id=85e1b8e2&"
import script from "./PwaUpdater.vue?vue&type=script&lang=js&"
export * from "./PwaUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports